import { Link } from "react-router-dom";
import "./library.css"; // Import a CSS file for styling
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import Logo from "../homepage/home_pictures/logos/Manga_Cons _Logo2.png";
import LibraryWelcome from "./Library/LibraryWelcome";
import LibraryBooks from "./Library/LibraryBooks";
import Footer from "../homepage/Footer";
import { useState } from "react";

export default function Library() {
  const [libDisp, setLibDisp] = useState("welcome");
  function toggleDisplay() {
    switch (libDisp) {
      case "welcome":
        return <LibraryWelcome />;
      case "books":
        return <LibraryBooks />;
      default:
        return <LibraryWelcome />;
    }
  }
  return (
    <div className="fx-cl">
      <header className="library-list-header fx-cl">
        {/* <div className="mcons-home-logo">
                    <Link to="/" className="loginLogo">
                    <img src={Logo} alt="mcons-logo" /> 
                    </Link>
                </div> */}
        <h2>Manga C.O.N.S Library</h2>
        <p>
          Introducing librarys Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Ex, possimus quam!
          <br />
          who drive our institution's excellence.
        </p>
      </header>
      <nav
        className="mcons-home-navbar-b "
        style={{ backgroundColor: "#64f727", padding: "4rem" }}
      >
        <div>
          <Link to="/">Home</Link>
        </div>
        <div className="mcons-home-nav-toggle">&#9776;</div>
        <ul className={`mcons-home-nav-menu-b fx-ac `}>
          <div className="home-nav dropdown">
            <li>
              <Link to="/administration" className="fx-ac ">
                <span>Administration</span>
                <KeyboardArrowRightIcon fontSize="large" />
              </Link>
            </li>

            <div className="home-nav dropdown-content ">
              <div className="administrationDropdown">
                <Link href="#home">Provost</Link>
                <Link href="#home">Deputy Provost Admin</Link>
                <Link href="#home">Deputy Provost library</Link>
                <Link href="#home">Registrar</Link>
                <Link href="#home">STDO</Link>
                <Link href="#home">College Bursar</Link>
                <Link href="#home">Chief Internal Auditor</Link>
                <Link href="#home">College Librarian</Link>
                <Link href="#home">Admission Officer</Link>
                <Link href="#home">Examination Officer</Link>
                <Link href="#home">Students Affair Officer</Link>
                <Link href="#home">library Secretary</Link>
              </div>
            </div>
          </div>
          <div className="home-nav dropdown">
            <li>
              <Link to="/academics" className="fx-ac ">
                <span>Academics</span>
                <KeyboardArrowRightIcon fontSize="large" />
              </Link>
            </li>
            <div className="home-nav dropdown-content">
              <Link href="#home">Basic Midwifery </Link>
              <Link href="#services">Basic Nursing</Link>
              <Link href="#about">Division of General Studies</Link>
            </div>
          </div>
          <div className="home-nav dropdown">
            <li>
              <Link to="/admission" className="fx-ac ">
                <span>Admission</span>
                <KeyboardArrowRightIcon fontSize="large" />
              </Link>
            </li>
            <div className="home-nav dropdown-content">
              <Link href="#home">Check Admission Status</Link>
              <Link href="#home">Application Requirement</Link>
            </div>
          </div>
          <li>
            <Link to="/library">Library</Link>
          </li>

          <div className="home-nav dropdown">
            <li>
              <Link to="/registrations" className="fx-ac ">
                <span>Registration</span>
                <KeyboardArrowRightIcon fontSize="large" />
              </Link>
            </li>

            <div className="home-nav dropdown-content">
              <Link to="/registrations">Apply now</Link>
              <Link href="#home">How to apply</Link>
            </div>
          </div>

          <li>
            <Link to="/about-us">About </Link>
          </li>
          <li>
            <Link to="/contact-us">Contant us</Link>
          </li>
        </ul>
        <div className="fx-ac space2">
          <span>
            <Link style={{ color: "#fff" }} to="/staff_login">
              Staffs
            </Link>
          </span>
          <Link
            className="home-nav-btn"
            onClick={() => setLibDisp("books")}
            style={{ backgroundColor: "#fff", color: "#065AD8" }}
          >
            BOOKS
          </Link>{" "}
        </div>
      </nav>
      {toggleDisplay()}
      <Footer />
    </div>
  );
}
